/**
 * `loading` is true while the promise given to `withLoading` runs: a table
 * shows its loader instead of stale rows (BaseContentTable's `loading`).
 */
export default {
  data() {
    return { loading: false }
  },
  methods: {
    withLoading(promise) {
      this.loading = true
      return Promise.resolve(promise).finally(() => {
        this.loading = false
      })
    }
  }
}
